import { Link } from 'gatsby';
import styled from 'styled-components';

export const ViewAllLink = styled(Link)`
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  user-select: none;
  font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : 'DINMediumAlternate '};
  border: 1px solid transparent;
  line-height: 1.5;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
  border-radius: 20px;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
  padding: 10px 1.5rem;
  min-width: 215px;
  text-align: center;
  text-transform: uppercase;
  background: #1b7bdd;
  transition: 0.3s;
  color: #fff;

  &.btn_bottom {
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    z-index: 1;
  }

  &.itineraries_btn {
    background-color: transparent;
    border-color: #1b7bdd;
    color: #1b7bdd;

    a {
      color: #1b7bdd !important;
    }

    &:hover {
      background-color: #1b7bdd;

      a {
        color: #fff !important;
      }
    }
  }

  a {
    color: #fff;
  }

  &:hover {
    background-color: #165ca3;
  }
`;

export const LoadMoreButton = styled.button`
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  line-height: 1.5;
  border-radius: 20px;
  padding: 10px 1.5rem;
  min-width: 215px;
  text-align: center;
  text-transform: uppercase;
  background: #1b7bdd;
  transition: 0.3s;
  color: #fff;

  &[dir='rtl'] {
    font-family: GESSTwoDWTCMedium, sans-serif;
    font-size: 14px;
  }

  &[dir='ltr'] {
    letter-spacing: 1.29px;
    font-size: 12px;
    font-family: 'DINMediumAlternate';
  }

  a {
    &[dir='rtl'] {
      font-family: GESSTwoDWTCMedium, sans-serif;
    }
    &[dir='ltr'] {
      font-family: 'DINMediumAlternate';
    }
  }

  &.btn_bottom {
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    z-index: 1;
  }

  &.itineraries_btn {
    background-color: transparent;
    border-color: #1b7bdd;
    color: #1b7bdd;

    a {
      color: #1b7bdd !important;
    }

    &:hover {
      background-color: #1b7bdd;

      a {
        color: #fff !important;
      }
    }
  }

  a {
    color: #fff;
  }

  &:hover {
    background-color: #165ca3;
  }
`;

export const LoadMoreHdn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0 0;

  &.cta_btn {
    margin: 2rem 0 0;
  }

  &.hdn_mdnsz {
    @media (max-width: 991px) {
      display: none;
    }
  }

  &.image_carouselbutton {
    @media (max-width: 575.98px) {
      margin: 2rem 0 0;
    }
  }
`;
